export class TerceroModel{
	public vnombre:string; 
	public sucursal:string;

	constructor(public id:TerceroId){}

}

export class TerceroId{
	constructor(public cid:string,
		public cnumcont:string,
		public cnumid:string , 
		public ctipid:string ,
		public cidregter:string ,
		public nporcentaje:number,
		public nestado:number){}
}




export class TerceroDetalleModel{
	constructor(public cnumcont:string,
		public cnumid:string , 
		public ctipid:string ,
		public vnombre:string, 
		public sucursal:string){}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearFactura/Tercero.model.ts